import React from 'react';
import '../stylesh/OutcomeHome.css';

// 🔹 Image imports
// import UnifiedCloud from '../../../assets/home/Unified-cloud-home.svg';
// import Reliablesupport from '../../../assets/home/e2e-transformation-home.svg';
// import BusinessResilience from '../../../assets/home/business-resilience-home.svg';
// import AcceleratePace from '../../../assets/home/accelerate-pace-home.svg';


import Reliablesupport from '../../../assets/home/e2e-transformation-home.svg';
import EnduserExperience from '../../../assets/home/End-userExperience.png';
import Modernization from '../../../assets/home/Modernization.png';
import SecurityAndCompliance from '../../../assets/home/SecurityAndCompliance.png';

const OutcomeHome = () => {
  const benefits = [
    {
      title: "Strong security and compliance",
      description:
        "Synectiks builds security into every layer with controls, encryption and continuous monitoring. Our Zero Trust approach helps protect data across endpoints, cloud environments, and virtual desktops. Our controls and processes are designed to support regulated environments, with logging and reporting capabilities that may help customers address requirements associated with frameworks such as SOC 2 and HIPAA.",
      image: SecurityAndCompliance
    },
    {
      title: "Reliable support for business continuity",
      description:
        "Your operations never sleep, and neither do we. We operate with 24/7 proactive monitoring, defined SLAs, and tested recovery processes to keep your business running. From backup and disaster recovery to secure remote access, Synectiks provides services designed to support availability and accelerate restoration following an incident. We also offer fully managed support services tailored to customer requirements.",
      image: Reliablesupport
    },
    {
      title: "Modernization with measurable outcomes",
      description:
        "We simplify technology operations and improve business performance through standardized delivery, automation, and measurable service outcomes. We modernize infrastructure and apps with clear targets, faster deployments, improved performance, lower operational effort, and cost optimization. Our standardized playbooks and automation reduce risk and variability, producing consistent, measurable improvements across environments.",
      image: Modernization
    },
    {
      title: "Proven end-user experience and unified control",
      description:
        "Empower your workforce with seamless, high-performance access. Users receive a familiar workspace across supported devices, with responsive access to applications and virtual desktops. IT teams gain centralized capabilities for provisioning, policy management, monitoring, and reporting, which can simplify operations and help reduce support requests.",
      image: EnduserExperience
    }
  ];

  return (
    <section className="outcome-container">
      <div className="outcome-inner">
        <h2 className="main-title">Why Synectiks?</h2>

        <div className="benefits-grid">
          {benefits.map((item, index) => (
            <div key={index} className="benefit-card">
              <div className="benefit-image">
                <img src={item.image} alt={item.title} />
              </div>

              <h3 className="benefit-title">{item.title}</h3>

              <p className="benefit-description">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OutcomeHome;